<template lang="pug">
.app-tags(v-if="tags.length && resultView != 'calendar'")
	span(v-if="siteName == 'ORG'" style="display:contents;")
		.app-tags__container
			.app-tags__group(v-for="group in tagsByFilterGroup")
				span.app-tags__group-title {{ group.name }}
				TransitionShuffle.app-tags__items(tag="div")
					AppTag(
						v-for="tag in group.tags"
						@click.native="removeTag(tag)"
						:key="'t1'+tag.id",
						:tag="tag")
		button.app-tags__clear(v-if="tags.length > 1" @click="clearAllTags" key="clear") Clear Filters
	span(v-else style="display:contents;")
		span.app-tags__title {{ config.tagsText }}
		TransitionShuffle.app-tags__items(tag="div")
			AppTag(
				v-for="tag in tags"
				@click.native="removeTag(tag)"
				:key="'t2'+tag.id",
				:tag="tag")
			button.app-tags__clear(v-if="tags.length > 1" @click="clearAllTags" key="clear") Clear Filters
</template>
  
<script>
import { mapGetters } from 'vuex';
import TransitionShuffle from '../../global/transitions/Shuffle.vue';
import AppTag from './Tag.vue';
export default {
  name: "AppTags",
  props: ["tags", "removeTag", "clearAllTags"],
  components: {
    TransitionShuffle,
    AppTag
  },
  data() {
    return {};
  },
  computed: {
		...mapGetters([
			"siteName",
			"filters",
			"resultView",
		]),
		appliedFilterGroups() {
			let tagIds = this.tags.map(tag => tag.id);
			return this.filters.filter(group => group.filters.some(filter => tagIds.includes(filter.id)) ||
				group.filters.some(filter => filter.filters?.some(f => tagIds.includes(f.id))));
		},
		tagsByFilterGroup() {
			return this.appliedFilterGroups.map(group => {
				return {
					name: group.name,
					tags: this.tags.filter(tag => group.filters.some(f => f.id == tag.id) ||
							group.filters.some(filter => filter.filters?.some(f => f.id == tag.id)))
				}
			});
		},
	},
  methods: {},
  created() { },
  mounted() { },
};
</script>

<style lang="scss" scoped>
.app-tags {
  display: flex;
  gap: 0.75rem;
  margin: 0 0 1rem;
	.page--RM & {
		flex-direction: column;
	}
	.page--ORG &,
	.page--TSP &,
	.page--TXC &,
	.page--BOB &,
	.page--BUY & {
		justify-content: space-between;
		align-items: flex-start;

		&__container {
			display: flex;
			gap: 1.25rem;
			flex-wrap: wrap;
			padding-top: 0.5rem;
		}
		&__group {
			display: flex;
			gap: 0.625rem;
			align-items: center;
			&-title {
				font-weight: 700;
			}
			&:not(:last-of-type) {
				padding-right: 1.25rem;
				position: relative;
				&::after {
					content: "";
					position: absolute;
					height: 1.125rem;
					width: 1px;
					background: $silverOrg;
					right: 0;
					bottom: 0.5rem;
				}
			}
		}
	}

	@include mqdn(lg_dn) {
		margin-top: 1rem;
	}

	@include mqdn(md_dn) {
		.page--ORG &,
		.page--TSP &,
		.page--TXC &,
		.page--BOB &,
		.page--BUY & {
			flex-direction: column;
			&__group {
				flex-wrap: wrap;
			}
		}
	}
	@include mqdn(sm_dn) {
		.page--ORG &,
		.page--TSP &,
		.page--TXC &,
		.page--BOB &,
		.page--BUY & {
			&__group {
				&:not(:last-of-type) {
					&::after {
						content: unset;
					}
				}
			}
		}
	}

  &__title {
    font-size: 0.875rem;
    color: $blue;
  }

  &__items {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.75rem;
    position: relative;
  }

  &__clear {
    appearance: none;
    all: unset;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    transition: 0.2s ease;
    cursor: pointer;
		.page--RM & {
			background: $blue;
			color: $white;
			font-size: 0.6875rem;
			line-height: 1;
			border-radius: 0.875rem;
			padding: 0 0.875rem;
			height: 1.75rem;
			&:hover {
				background: $red;
			}
			&::after {
				content: "\00D7";
				font-size: 0.75rem;
				font-weight: 700;
				line-height: 0;
			}
		}
		.page--ORG &,
		.page--TSP &,
		.page--TXC &,
		.page--BOB &,
		.page--BUY & {
			background: $white;
			border-radius: 5px;
			font-size: 0.875rem;
			line-height: 1rem;
			min-width: 160px;
			font-weight: 700;
			display: flex;
			justify-content: center;
			padding: 0.875rem 2rem;
			&:hover {
				color: $white;
			}
		}
		.page--ORG & {
			color: $brightBlueAltOrg;
			border: solid 1px $brightBlueAltOrg;
			&:hover {
				background: $brightBlueAltOrg;
			}
		}
		.page--TSP & {
			color: $primarytsp;
			border: solid 1px $primarytsp;
			&:hover {
				background: $primarytsp;
			}
		}
		.page--TXC & {
			color: $primarytxc;
			border: solid 1px $primarytxc;
			&:hover {
				background: $primarytxc;
			}
		}
		.page--BOB & {
			color: $primarybob;
			border: solid 1px $primarybob;
			&:hover {
				background: $primarybob;
			}
		}
		.page--BUY & {
			color: $primarybuy;
			border: solid 1px $primarybuy;
			&:hover {
				background: $primarybuy;
			}
		}
  }
}
</style>